/* 🤖 this file was generated by svg-to-ts */
export const svgBackArrow: {
    name: "back-arrow";
    data: string;
} = {
    name: "back-arrow",
    data: '<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__back-arrow" viewBox="0 0 20 15"><g id="ng__path-back-arrow" fill="none" transform="translate(-15 -94) translate(16 94) translate(.8 .2)"><path d="M-3 4 3.4 10.4 9.8 4" transform="rotate(90 3.4 7.2)"/><path d="M1.2,7.2 L17.2,7.2"/></g></symbol></svg>',
};
